// Generated by scripts/mdi/import-questionnaires.mjs from MDI "PT-141 (Bremelanotide) INJECTION (Men and women) 09.17.26" (159366e4-7401-4824-b6f2-2ffd93e8008a). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiPT141BremelanotideInjectionMenAndWomenQuestions = [
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_sex',
    label: 'What was your sex assigned at birth?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'male', value: 'Male' },
        { key: 'female', value: 'Female' }
      ]
    }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_takingMedicationsPsychiatricConditionsE',
    label:
      'Are you currently taking any medications for psychiatric conditions (e.g., antidepressants, antipsychotics, or mood stabilizers)?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'de2e9181-07c7-41f6-a993-e2e6b00057db' }
  },
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication',
    label: 'Please list the name of the medication',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication'
    },
    extras: { mdiQuestionId: 'df659dcd-6d0a-4a22-b6e9-ae747ccbf34d' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_takingOpiateNarcoticMedications',
    label: 'Are you currently taking any Opiate or Narcotic medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '77535001-abad-48c6-be19-027cb8b590b5' }
  },
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication2',
    label: 'Please list the name of the medication',
    type: 'info',
    answer: {
      type: 'text',
      name: 'mdiPT141BremelanotideInjectionMenAndWomen_listNameMedication2'
    },
    extras: { mdiQuestionId: '11b817af-1e1e-44e8-8b81-650b9ce3513a' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_pregnantTryingBecomePregnantBreastfeeding',
    label:
      'Are you currently pregnant, trying to become pregnant, or breastfeeding?',
    type: 'select',
    educationalSlide:
      'The FDA has NOT assigned a specific pregnancy category for PT-141 (Bremelanotide) but labeling advises against use. Women of reproductive potential are urged to use contraception and stop use if pregnancy is confirmed.',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'ad755e27-92a5-4496-b225-f38ba0dd062a' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe',
    label: 'Pregnancy/Breastfeeding Medically Unsafe',
    type: 'info',
    subLabel:
      'You mentioned you are planning on pregnancy, actively pregnant, or breastfeeding. For the safety or your child, you are not a candidate for PT-141 (Bremelanotide) at this time. Please email [customer_support_email] for alternative options.',
    answer: {
      type: 'text',
      name: 'mdiPT141BremelanotideInjectionMenAndWomen_pregnancyBreastfeedingMedicallyUnsafe',
      rows: 4
    },
    extras: { mdiQuestionId: 'e01bbfb6-288a-4cf3-b2e6-9b2b29f0bbd4' }
  },
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_medicalConditions',
    label: 'Do you have any of the following medical conditions?',
    type: 'select',
    educationalSlide:
      '• History of heart attack (myocardial infarction)\n&#10;• &#10;Chest pain (angina)\n&#10;\n&#10;• &#10;Stroke or mini-stroke (TIA)\n&#10;\n&#10;• &#10;Severe high blood pressure (hypertension not well-controlled)\n&#10;\n&#10;• &#10;Severe low blood pressure (hypotension)\n&#10;\n&#10;• &#10;Irregular heartbeat (arrhythmias, atrial fibrillation, etc.)\n&#10;\n&#10;• &#10;Heart failure',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: '106a4924-1985-4325-bfd0-ec0f0dcf12db' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueMedicalConditions',
    label:
      "I'm sorry, due to your medical conditions, it is not safe for you to take PT-141 (Bremelanotide)",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: 'b25820a0-5f77-4332-9b94-e4efc83a2f22',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_experiencedFrequentNauseaVomitingMotion',
    label:
      'Have you experienced frequent nausea, vomiting, or motion sickness?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        { key: 'yes', value: 'Yes' }
      ]
    },
    extras: { mdiQuestionId: 'acee00e5-fc98-41eb-ba65-90195ba65714' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_takingSpecificMedicationsHighBlood',
    label:
      'Are you currently taking any of the following specific medications for high blood pressure?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'clonidine', value: 'Clonidine' },
        {
          key: 'beta_blockers_e_g_metoprolol_atenolol_pr',
          value: 'Beta-blockers (e.g., metoprolol, atenolol, propranolol)'
        },
        {
          key: 'diuretics_e_g_furosemide_hydrochlorothia',
          value:
            'Diuretics (e.g., furosemide, hydrochlorothiazide [HCTZ], spironolactone)'
        },
        {
          key: 'nitrate_medications_e_g_nitroglycerin_is',
          value:
            'Nitrate medications (e.g., nitroglycerin, isosorbide mononitrate, isosorbide dinitrate)'
        },
        { key: 'im_not_sure', value: "I'm not sure" },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: '4c4587d8-d2e9-4462-9558-03b43819a41f' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_imSorryDueCurrentMedications',
    label:
      "I'm sorry, due to your current medications, you are not an ideal candidate for PT-141 (Bremelanotide)",
    type: 'info',
    answer: {},
    class: 'ineligible',
    reject: true,
    blockQuestionFlow: true,
    isLast: true,
    extras: {
      mdiQuestionId: '346cd5e6-05e3-4d2f-b63a-e9092be77eec',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_lastTimePersonMedicalEvaluation',
    label:
      'When was the last time you had an in person medical evaluation including laboratory tests?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        { key: 'less_than_a_year_ago', value: 'Less than a year ago' },
        { key: 'o_1_to_2_years_ago', value: '1 to 2 years ago' },
        { key: 'more_than_2_years_ago', value: 'More than 2 years ago' }
      ]
    },
    extras: { mdiQuestionId: 'e539d8b1-a76d-4c77-912e-f233aafd300f' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the consent  (https://drive.google.com/file/d/10ifKkN1B1jP5RU82mPC2L4hrFeGj-t6U/view)\n\nType your full legal name below to proceed',
    answer: {
      type: 'text',
      name: 'mdiPT141BremelanotideInjectionMenAndWomen_importantClickAttachedLinkReview'
    },
    extras: { mdiQuestionId: 'f6479e4d-6aba-4c24-a113-98e2aadfb8b8' }
  },
  {
    field:
      'mdiPT141BremelanotideInjectionMenAndWomen_readAboutPt141Bremelanotide',
    label: 'Please read the following about PT-141 (Bremelanotide)',
    type: 'info',
    subLabel:
      'About PT-141 (Bremelanotide):PT-141 is a melanocortin receptor agonist that can increase sexual desire and arousal. It is FDA-approved for hypoactive sexual desire disorder in women and is used off-label for men with low libido.\n\nHow to use:\nUse no more than 8 doses per month.\nInject 30-60 minutes before sexual activity.\nCommon side effects include nausea, flushing, and headache.\nAvoid use with uncontrolled high blood pressure, heart disease, or pregnancy.',
    answer: {},
    extras: {
      mdiQuestionId: '86525ab9-e143-40f7-ba08-b9377ce92321',
      sendToBeluga: false,
      sendToMdi: false
    }
  },
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_firstMessageDoctor',
    label: 'This is your first message to your doctor.',
    type: 'info',
    subLabel:
      'Please introduce yourself and give any other information about yourself and your health that you would like to.',
    answer: {
      type: 'text',
      name: 'mdiPT141BremelanotideInjectionMenAndWomen_firstMessageDoctor',
      rows: 4,
      placeholder:
        'Example: "Hi doctor, other than what I already answered I am otherwise health and excited to get started."'
    },
    extras: { mdiQuestionId: '4b9c4adf-56ce-4bf8-87e9-3aaa9c9bf69e' }
  },
  {
    field: 'mdiPT141BremelanotideInjectionMenAndWomen_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiPT141BremelanotideInjectionMenAndWomenAnswerField = Partial<
  QuestionAnswerMap<typeof mdiPT141BremelanotideInjectionMenAndWomenQuestions>
>;

export default mdiPT141BremelanotideInjectionMenAndWomenQuestions;
